var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("span", { staticClass: "search-header" }, [
          _vm._v(_vm._s(_vm.$t("pages.payroll.searching_header"))),
        ]),
        _c("img", {
          attrs: { src: require("@/assets/IC_Minimise.png"), alt: "min" },
        }),
      ]),
    ]),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col" }, [
        _c("form", [
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("appointment-status-field", {
                  attrs: { id: "status", name: "status", form: _vm.form },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col text-right" },
        [
          _c(
            "a",
            {
              staticClass: "mx-4 search-clean",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.clear.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.actions.clear")))]
          ),
          _c("vue-button", {
            staticClass: "btn-primary search-button",
            attrs: { title: _vm.$t("components.actions.search") },
            on: { click: _vm.searchClicked },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }